
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/residents/signup",
      function () {
        return require("private-next-pages/residents/signup/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/residents/signup"])
      });
    }
  